import { faClone } from '@fortawesome/free-solid-svg-icons';
import { ModuleTypeEnum } from '../../enums';
import { IModuleConfig } from '../../interfaces';
import { BackButton } from '../reports/components/toolbar-items';
import { UserPermissions } from '../../definitions';
import { FancyCard, ItemPage } from './components';
import { getSingleProducts, getSubscriptions } from './service/dataService';
import SaveButton from './components/toolbar-items/SaveButton';
import { ISubscriptionTiers } from './types';

const config: IModuleConfig = {
  id: 'subscription',
  name: 'Subscriptions',
  view_permission: UserPermissions.viewSubscription,
  edit_permission: UserPermissions.editSubscription,
  icon: faClone,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: FancyCard,
    itemPage: ItemPage
  },
  services: {
    getByPage: getSubscriptions,
    getSingle: getSingleProducts
  },
  utilities: {
    extractKey: (d: ISubscriptionTiers) => d._id,
    extractItemPath: (d: ISubscriptionTiers) => d._id,
    extractItemBreadcrumb: (d: ISubscriptionTiers) => `${d._id}`
  },
  toolbarItems: {
    library: [],
    create: [],
    edit: [BackButton, SaveButton],
    view: []
  }
};

export default config;
